import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card } from "antd";



const Search = ({ dispatch, initialFilters, searchLoading }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            code: initialFilters?.code,
            name: initialFilters?.name,
            surname: initialFilters?.surname,
            referues: initialFilters?.referues,
        });
    }, [form, initialFilters]);


    const searchClickHandler = () => {
        const filter_click = {
            type: "set_clicked",
            payload: true,
        };
        dispatch(filter_click);

        const requestFilters = {
            nid: form.getFieldValue("code") ? form.getFieldValue("code") : null,
            name: form.getFieldValue("name") ? form.getFieldValue("name") : null,
            surname: form.getFieldValue("surname") ? form.getFieldValue("surname") : null,
            referues: form.getFieldValue("referues") ? form.getFieldValue("referues") : null,
        };

        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card bodyStyle={{ paddingBottom: "0" }}>
                    <Form
                        layout="vertical"
                        form={form}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={24} align="bottom">
                            <Col xl={5} lg={5} md={24} sm={24} xs={24}>
                                <Form.Item name="code" label="Kodi:">
                                    <Input
                                        name="code"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={5} lg={5} md={24} sm={24} xs={24}>
                                <Form.Item name="name" label="Emri:">
                                    <Input
                                        name="name"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={5} lg={5} md={24} sm={24} xs={24}>
                                <Form.Item name="surname" label="Mbiemri:">
                                    <Input
                                        name="surname"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={5} lg={5} md={24} sm={24} xs={24}>
                                <Form.Item name="referues" label="Referuesi:">
                                    <Input
                                        name="referues"
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-center">
                                <Form.Item>
                                    <Button
                                        block
                                        type="primary"
                                        size="medium"
                                        loading={searchLoading}
                                        icon={<SearchOutlined />}
                                        onClick={() => searchClickHandler()}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};


export default Search;